import Compressor from "compressorjs";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.min.mjs";
const DEFAULT_LOCALE = { code: "en-US", currency: "USD" };
// Helper: Convert Blob/File to base64
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
  });

// Helper: Compress images using compressorjs
export const compressImage = (file) =>
  new Promise((resolve) => {
    new Compressor(file, {
      quality: 0.95,
      maxWidth: 1920,
      maxHeight: 1920,
      success(result) {
        resolve(result);
      },
      error() {
        resolve(file); // Fallback to original file on error
      },
    });
  });

// Helper: Compress PDF by rasterizing pages
export const compressPDF = async (file) => {
  const pdfData = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
  const pdfDoc = await PDFDocument.create();

  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale: 1 });

    // Render page into canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({ canvasContext: ctx, viewport }).promise;

    // Compress canvas to JPEG
    const jpegDataUrl = canvas.toDataURL("image/jpeg", 0.95);
    const imgBytes = await fetch(jpegDataUrl).then((res) => res.arrayBuffer());

    // Embed in new PDF
    const img = await pdfDoc.embedJpg(imgBytes);
    const pdfPage = pdfDoc.addPage([viewport.width, viewport.height]);
    pdfPage.drawImage(img, {
      x: 0,
      y: 0,
      width: viewport.width,
      height: viewport.height,
    });
  }

  const compressedBytes = await pdfDoc.save();
  return new File([compressedBytes], file.name.replace(/\s+/g, "_"), {
    type: "application/pdf",
  });
};

// Helper: Format file size for display
export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};
function processInput(inputValue) {
  if (inputValue == null || Number.isNaN(inputValue)) return null;
  return Number(inputValue);
}

export function fNumber(inputValue, options) {
  //
  // const locale = formatNumberLocale() || DEFAULT_LOCALE;
  const locale = DEFAULT_LOCALE;

  const number = processInput(inputValue);
  if (number === null) return "";

  const fm = new Intl.NumberFormat(locale.code, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(number);

  return fm;
}
